<template>
  <div>
    <data-form
      ref="searchForm"
      :content="searchContent"
      :data="searchFormData"
      :fixedLabelWidth="true"
      :labelCol="4"
      :colnum="8"
      :showButton="false"
      style="width:100%;"
    >
      <template slot="dateRange">
        <a-date-picker
          :disabledDate="disabledStartDate"
          format="YYYY-MM-DD"
          v-model="StartTime"
          :allowClear="false"
          style="width:46%"
        />
        <span style="width:1%"> - </span>
        <a-date-picker
          :disabledDate="disabledEndDate"
          format="YYYY-MM-DD"
          v-model="EndTime"
          :allowClear="false"
          style="width:46%"
        />
      </template>
      <template slot="search">
        <a-button style="margin-left:10px;" type="primary" @click="handleSearch"
          >搜索</a-button
        >
      </template>
    </data-form>
    <a-collapse accordion :bordered="false" v-if="bookingList.length">
      <a-collapse-panel v-for="(item, index) in bookingList" :key="index">
        <template slot="header">
          <h2 class="hd-name">{{ item.CompanyName }}</h2>
          <p class="info">
            <span>剩余房量：{{ item.RestRoomCount }}</span>
            <span>订房热线：{{ item.BookingPhone }}</span>
            <span>地址：{{ item.Address }}</span>
          </p>
        </template>
        <div class="inner">
          <div style="max-height: 300px; overflow: auto;">
            <table class="room-table">
              <thead>
                <tr>
                  <th>房型</th>
                  <th>价格</th>
                  <th>总房量</th>
                  <th>允许超订</th>
                  <th>可预订</th>
                  <th>预订数量</th>
                </tr>
              </thead>
              <tbody v-if="item.Details.length">
                <tr v-for="(dItem, dIndex) in item.Details" :key="dIndex">
                  <td>{{ dItem.RoomTypeName }}</td>
                  <td>{{ dItem.RoomTypePrice }}</td>
                  <td>{{ dItem.TotalRoomCount }}</td>
                  <td>{{ dItem.OversellNum }}</td>
                  <td>{{ dItem.AvailableRoomCount }}</td>
                  <td>
                    <a-input-number
                      size="small"
                      :min="0"
                      v-model="dItem.OrderRoomCount"
                      @change="onChangeNumber($event, dItem, item)"
                    />
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="5">暂无数据！</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="btn-box">
            <span class="total-number"> 总计：{{ item.totalNumber }}</span>
            <a-button
              type="primary"
              :disabled="item.totalNumber == 0"
              @click="orderRoom(item)"
              >预订</a-button
            >
          </div>
        </div>
      </a-collapse-panel>
    </a-collapse>
    <div class="no-data" v-else>暂无数据</div>
    <a-pagination
      :total="total"
      :pageSize="pageSize"
      showSizeChanger
      showQuickJumper
      @change="handlePageChange"
      @showSizeChange="onShowSizeChange"
    />
  </div>
</template>

<script>
import { cache } from "@/utils/common";
import moment from "moment";
moment.locale("zh-cn");
import { DataForm } from "@/components/dataForm";
import { GroupRoomOrderModal } from "@/views/groupOrderManage/index.js";

export default {
  name: "groupmanage_roomorder",
  components: { DataForm },
  data() {
    return {
      user: null,
      searchFormData: {},
      StartTime: null,
      EndTime: null,
      defaultDateValue: [],
      bookingList: [],
      roomOptions: {},
      // defaultTime: {},
      pagination: {},
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.form.getFieldDecorator("keys", { initialValue: [], preserve: true });
    this.searchContent = [
      {
        label: "门店",
        name: "CompanyId",
        placeholder: "请选择门店",
        type: "select",
        api: "GetGroupSelectItems",
        param: { Types: "company" },
        valueField: "Id",
        textField: "Text",
        dataField: "Data.company"
      },
      {
        label: "日期",
        colnum: 2,
        slot: "dateRange"
      },
      {
        label: "关键字",
        name: "KeyWord",
        colnum: 2,
        props: {
          placeholder: "请输入门店名称/位置"
        }
      },
      {
        label: "",
        slot: "search"
      }
    ];
  },
  created() {
    this.user = cache.get("user");
    this.StartTime = moment(this.user.AccountDate);
    this.EndTime = moment(this.user.AccountDate).add("days", 1);
  },
  mounted() {
    this.getBookingList();
  },
  methods: {
    disabledStartDate(StartTime) {
      const EndTime = this.EndTime;
      if (!StartTime || !EndTime) {
        return false;
      }
      return StartTime.valueOf() > EndTime.valueOf();
    },
    disabledEndDate(EndTime) {
      const StartTime = this.StartTime;
      if (!EndTime || !StartTime) {
        return false;
      }
      return StartTime.valueOf() >= EndTime.valueOf();
    },
    //获取集团预订列表
    getBookingList() {
      this.$nextTick(() => {
        const fields = this.$refs.searchForm.getData();
        const param = {
          Area: fields.Area,
          CompanyId: fields.CompanyId,
          BeginDate: moment(this.StartTime).format("YYYY-MM-DD"),
          EndDate: moment(this.EndTime).format("YYYY-MM-DD"),
          KeyWord: fields.KeyWord,
          PageIndex: this.currentPage - 1,
          PageSize: this.pageSize
        };
        this.$post("GroupOrder_BookingList", param).then(res => {
          this.bookingList = res.Data.Datas.map(v => {
            this.$post("GroupOrder_Room_GetDefaultTime", {
              CompanyId: v.Id
            }).then(result => {
              v.defaultTime = {};
              result.Data.TimeList.forEach(item => {
                if (
                  item.Code == "ArrivalsTime" ||
                  item.Code == "DepartureTime"
                ) {
                  v.defaultTime[item.Code] = item.Value;
                }
              });
              v.defaultTime.IsIndependentPriceCode =
                result.Data.IsIndependentPriceCode;
              v.defaultPriceCodeId = result.Data.PriceCodeId;
            });
            v.totalNumber = 0;
            v.Details = v.Details.map(el => {
              el.key = el.Id;
              // el.Available =
              //   Number(el.OversellNum) + Number(el.AvailableRoomCount);
              return el;
            });
            return v;
          });
          this.total = res.Data.Total;
        });
      });
    },
    //搜索
    handleSearch() {
      this.currentPage = 1;
      this.getBookingList();
    },
    //分页
    handlePageChange(current) {
      this.currentPage = current;
      this.getBookingList();
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize;
      this.getBookingList();
    },
    //选择预订房间数量
    onChangeNumber(values, record, item) {
      if (values > record.AvailableRoomCount) {
        record.OrderRoomCount = record.AvailableRoomCount;
        this.$message.error("不能超过可预订房数");
      }
      let total = 0;
      item.Details.forEach(element => {
        if (element.OrderRoomCount != undefined) {
          total += Number(element.OrderRoomCount);
        }
      });
      item.totalNumber = total;
    },
    //预订
    orderRoom(item) {
      this.roomOptions.roomInfoData = [];
      // const fields = this.$refs.searchForm.form.getFieldsValue();
      item.Details.forEach(v => {
        if (v.OrderRoomCount && v.OrderRoomCount > 0) {
          const startDate = moment(
            moment(this.StartTime).format("YYYY-MM-DD") +
              " " +
              item.defaultTime.ArrivalsTime,
            "YYYY-MM-DD hh:mm"
          );
          const endDate = moment(
            moment(this.EndTime).format("YYYY-MM-DD") +
              " " +
              item.defaultTime.DepartureTime,
            "YYYY-MM-DD hh:mm"
          );
          for (let i = 0; i < v.OrderRoomCount; i++) {
            this.roomOptions.roomInfoData.push({
              CheckInTime: startDate,
              CheckOutTime: endDate,
              OriginCheckOutTime: endDate,
              RoomId: "",
              RoomNo: "",
              RoomTypeId: v.RoomTypeId,
              RoomTypeName: v.RoomTypeName,
              PriceStructureId: "",
              Persons: [],
              IDCardCount: 0,
              TransactionPrices: [],
              BaseTransactionPrices: [],
              RoomPrice: v.RoomTypePrice
            });
          }
        }
      });
      GroupRoomOrderModal({
        actionType: "order",
        options: this.roomOptions,
        priceCodeId: item.defaultPriceCodeId,
        defaultItem: item.defaultTime,
        submitApi: "GroupOrder_CreateOrder",
        CompanyId: item.Id,
        update: () => {
          this.getBookingList();
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.ant-collapse {
  border-top: 1px solid #eaeaea;
  border-radius: 0;
  margin-top: 10px;
}
.ant-collapse > .ant-collapse-item {
  border-bottom: 1px solid #eaeaea;
  /deep/ & > .ant-collapse-header {
    padding-left: 10px;
    .arrow {
      left: 96%;
    }
    &:hover {
      background: #e6f7ff;
    }
  }
}
.info {
  color: #888;
  font-size: 12px;
  span {
    margin-right: 15px;
  }
}
.hd-name {
  color: #333;
  line-height: 1.8;
  font-size: 16px;
}
.inner {
  position: relative;
  .room-table {
    width: 100%;
  }
  .room-table tr > th {
    padding: 2px 8px;
    background: #ffd73d;
    text-align: center;
  }
  .room-table tr > td {
    padding: 5px 8px;
    text-align: center;
    background: #f9f9f9;
    border-bottom: 1px solid #fff;
  }
  .btn-box {
    text-align: right;
    margin: 10px 0 0;
    .total-number {
      color: #000;
      font-size: 16px;
      margin-right: 20px;
    }
  }
}
.ant-pagination {
  margin-top: 10px;
  text-align: right;
}
.no-data {
  text-align: center;
  padding: 30px 0;
  border: 1px solid #eee;
}
.data-form-box /deep/ .fixed-label-width .ant-form-item .ant-form-item-label {
  width: 80px;
}
/*滚动条样式*/
// .inner ::-webkit-scrollbar {
//   width: 4px;
//   height: 5px;
// }
// .inner ::-webkit-scrollbar-thumb {
//   border-radius: 5px;
//   box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
//   background: rgba(0, 0, 0, 0.2);
// }
// .inner ::-webkit-scrollbar-track {
//   box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
//   border-radius: 0;
//   background: #eee;
// }
</style>
